import css from './numbers.module.scss';

import { memo } from 'react';
import { useParams } from 'react-router-dom';

import { FrameHeader } from 'core/ui/Frame';
import LangIcon from 'core/ui/LangIcon';

import Buttons from './Buttons';
import Tableau from './Tableau';
import useNumbers from './hooks/useNumbers';

const Numbers = () => {
  const lang = orDie(useParams<{ lang?: TLang }>().lang);
  const {
    status,
    chosen,
    value,
    isAudioLoading,
    replay,
    onAddSym,
    correct,
    wrong,
  } = useNumbers(lang);

  return (
    <>
      <FrameHeader>
        <LangIcon className={css.langIcon} lang={lang} />
        Numbers
        {correct || wrong ? (
          <>
            {': '}
            {correct > 0 && (
              <span className={css.counterCorrect}>{correct}</span>
            )}
            {correct > 0 && wrong > 0 && ', '}
            {wrong > 0 && <span className={css.counterWrong}>{wrong}</span>}
          </>
        ) : null}
      </FrameHeader>

      <div className={css.root} data-status={status}>
        <Tableau
          value={value}
          chosen={chosen}
          isAudioLoading={isAudioLoading}
        />
        <Buttons
          onReplay={replay}
          onAddSym={onAddSym}
          isEmpty={chosen.length === 0}
          disabled={status !== 'none' || isAudioLoading}
        />
      </div>
    </>
  );
};

export default memo(Numbers);
